import styled from "styled-components";
import { Control, UseFormSetValue, useWatch } from "react-hook-form";
import { FC } from "react";

import { Label } from "@/components/Forms";
import Text from "@/components/Text";
import { FormDataT } from "./ThumbsAndTitlesFormModal";

const Box = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px;
  margin-top: 24px;
`;

const Heading = styled(Text)`
  margin-bottom: 12px;
`;

const Inputs = styled.div`
  display: flex;
  margin-top: 18px;
  gap: 32px;
`;

const StyledLabel = styled(Label)`
  position: relative;
  cursor: pointer;
  user-select: none;
  margin: 0;
  padding-left: 25px;
`;

const RadioCircle = styled.span`
  width: 16px;
  height: 16px;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  position: absolute;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 1px;
  transition: 0.2s ease-out all;
  border-radius: 50%;
  transition: border-color ease-out 0.2s;
  &:after {
    content: "";
    position: absolute;
    opacity: 0;
    width: 8px;
    height: 8px;
    background: ${({ theme }) => theme.colors.purple};
    border-radius: 50%;
    left: 2px;
    top: 2px;
    transition: opacity ease-out 0.2s;
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  border-radius: 50%;
  &:checked ~ ${RadioCircle} {
    border-color: ${({ theme }) => theme.colors.purple};
    &::after {
      opacity: 1;
    }
  }
`;

interface Props {
  control: Control<FormDataT, object>;
  setValue: UseFormSetValue<FormDataT>;
}

const CompetitionField: FC<Props> = ({ control, setValue }) => {
  const value = useWatch({
    name: "c_batch",
    control,
  });

  return (
    <Box>
      <Heading $type="smallBold">Thumb Competition</Heading>
      <Text $type="smallNormal" $color="gray">
        Start the thumbnail competition by selecting the correct sequence to
        follow.
      </Text>
      <Inputs>
        <StyledLabel>
          None
          <Input
            type="radio"
            name="selection"
            checked={value === 0}
            onChange={() => setValue("c_batch", 0)}
          />
          <RadioCircle />
        </StyledLabel>
        <StyledLabel>
          C1
          <Input
            type="radio"
            name="selection"
            checked={value === 1}
            onChange={() => setValue("c_batch", 1)}
          />
          <RadioCircle />
        </StyledLabel>
        <StyledLabel>
          C2
          <Input
            type="radio"
            name="selection"
            checked={value === 2}
            onChange={() => setValue("c_batch", 2)}
          />
          <RadioCircle />
        </StyledLabel>
      </Inputs>
    </Box>
  );
};

export default CompetitionField;
